// import node module libraries
import { Fragment, useState, useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Col, Row, Card, Form, Button, Spinner, OverlayTrigger, Tooltip, Image } from 'react-bootstrap';

// import custom components
import PasswordStrengthMeter from 'components/elements/passwordstrength/PasswordStrengthMeter';

// import axios
import axios from 'axios';

// import media files
import Logo from 'assets/images/brand/logo/logo-icon.svg';

// import notification component
import Notification, { handleShowNotification } from 'components/elements/notification/Notification';

const ForgetPassword = () => {
	const [notification, setNotification] = useState({ variant: '', title: '', message: '' });
	const [isButtonDisabled, setIsButtonDisabled] = useState(false);
	const [isSubmitted, setIsSubmitted] = useState(false);
	const [isLoading, setIsLoading] = useState(false); // State for loading spinner

	const handleSubmitResetLink = async (e) => {
		e.preventDefault();
		setIsButtonDisabled(true);
		setIsLoading(true); // Set loading to true

		// API-Call Options
		const options = {
		};

		const data = {
			username: e.target.username.value
		};

		// Dynamische URL basierend auf der Umgebung
		const baseURL = process.env.REACT_APP_ENV === 'development'
			? `http://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`
			: `https://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`;

		await axios.patch(`${baseURL}/auth/forgot-password`, data, options)
			.then(response => {
				// Disable Form and Button after submission
				setIsSubmitted(true);
				handleShowNotification(setNotification, 'info', 'Information', response.data.message);
			})
			.catch((error) => {
				const errorMessage = error.response?.data?.message ? error.message + '. ' + error.response.data.message : error.message;
				handleShowNotification(setNotification, 'danger', 'Fehler', errorMessage + '. Bitte versuche es erneut oder kontaktiere den HelpDesk.');	
				setIsButtonDisabled(false);
				setIsLoading(false); // Stop loading
			});
	};

	return (
		<Fragment>
			{notification.show && (
				<Notification variant={notification.variant} title={notification.title} message={notification.message} show={notification.show} setNotification={setNotification} />
			)}
			<Row className="align-items-center justify-content-center g-0 min-vh-100">
				<Col lg={5} md={5} className="py-8 py-xl-0">
					<Card>
						{isSubmitted === null ? '' : isSubmitted ?
						<Card.Body className="p-6">
							<div className="mb-4">
								<Link to="/">
									<Image src={Logo} className="mb-4" alt="" />
								</Link>
								<h1 className="mb-1 fw-bold">Passwort vergessen</h1>
									<span>Wir haben dir an die hinterlegte Adresse einen Link zum Zurücksetzen deines Passwortes geschickt.</span>
							</div>
							<hr className="my-4" />
							<div className="mt-4 text-center">
								<span>
									Du kannst dieses Fenster nun schließen oder gehe zurück zur {' '}
									<Link to="/authentication/sign-in">
										Anmeldung
									</Link>
								</span>
							</div>
						</Card.Body>:
						<Card.Body className="p-6">
						<div className="mb-4">
							<Link to="/">
								<Image src={Logo} className="mb-4" alt="" />
							</Link>
							<h1 className="mb-1 fw-bold">Passwort vergessen</h1>
							<span>Hast du dein Passwort verlegt? Kein Problem, wir senden dir eine E-Mail, damit du dein Passwort zurücksetzen kannst.</span>
						</div>
						{/* Form Passwort Change if username and token served */}
						<Form onSubmit={handleSubmitResetLink}>
							<Row>
								<Col lg={12} md={12} className="mb-3">
									{/*  email */}
									<Form.Label>E-Mail</Form.Label>
									<Form.Control
										type="email"
										id="username"
										placeholder="E-Mail angeben"
										autoComplete="username"
										required
									/>
								</Col>
								<Col lg={12} md={12} className="mb-3 d-grid gap-2">
									{/* Button */}
									<Button variant="primary" type="submit" disabled={isButtonDisabled}>
										{isLoading ? (
											<>
												<Spinner animation="border" size="sm" className="me-2" />
												Passwort zurücksetzen
											</>
										) : (
											'Passwort zurücksetzen'
										)}
									</Button>
								</Col>
							</Row>
						</Form>
						<hr className="my-4" />
						<div className="mt-4 text-center">
							<span>
								Zurück zur {' '}
								<Link to="/authentication/sign-in">
									Anmeldung
								</Link>
							</span>
						</div>
						</Card.Body>}						
					</Card>
				</Col>
			</Row>
		</Fragment>
	);
};

export default ForgetPassword;
